import * as Sentry from '@sentry/react'
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
  Routes,
} from 'react-router-dom'
import { useEffect } from 'react'

export const initSentry = () => {
  process.env.NODE_ENV === 'production' &&
    Sentry.init({
      dsn: 'https://a64c9b6ae95127a615e4f3d9bc6feb9f@o4508647038517248.ingest.us.sentry.io/4508650481319936',
      integrations: [
        Sentry.reactRouterV6BrowserTracingIntegration({
          useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
        }),
        Sentry.feedbackIntegration({
          colorScheme: 'light',
          accentColor: '#000',
          namePlaceholder: 'Type your name here',
          emailPlaceholder: 'Type your email here',
          showBranding: false,
        }),
      ],
      environment: 'production',
      tracesSampleRate: 1.0,
      tracePropagationTargets: ['localhost', /^https?:\/\/poridhi\.io/],
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    })
}

export const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes)
